import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PricingExample } from '../../../pages/examples/PricingExample';

export const Route = createFileRoute('/_private/_home/pricing')({
  component: PricingRoute,
});

function PricingRoute() {
  const { apiClient } = Route.useRouteContext();
  return <PricingExample portalApiClient={apiClient} />;
}
